import { For, Show } from 'solid-js'
import './list-view.css'
import { useReportBrowser } from './report-browser-context'
import { ReportGroup, ReportInfoCard } from 'st-app/api'
import STButton, { ButtonType } from '../st-button/st-button'
import ReportEditMenu from './report-edit-menu'
import SideNav from './side-nav'

export const ListView = () => {
    const reportBrowser = useReportBrowser()!

    return (
		<div style="display: flex; justify-content: center; overflow-y: auto; padding-block: 8px;">
			<Show when={!reportBrowser.shouldShowReports()}>
				<GroupTable groups={reportBrowser.state.groups}></GroupTable>
			</Show>

			<Show when={reportBrowser.shouldShowReports()}>
				<div style="display: flex; flex-grow: 1;">
					<SideNav></SideNav>
					<ReportTable reports={reportBrowser.reports()}></ReportTable>
				</div>
			</Show>

		</div>
		// <div style="display: flex; flex: 1; align-items: stretch; position: relative; height: 100%; gap: 4px;">
		// 	<div style="position: relative; width: 100px; align-self: stretch;">
		// 		<div style="position: absolute; height: 100%; overflow-y: auto;">
		// 			<SideNav></SideNav>
		// 		</div>
		// 	</div>
		// 	<div class="report-browser-list-container">
		// 		<Show when={!shouldShowReports()}>
		// 			<GroupTable groups={reportBrowser.groups}></GroupTable>
		// 		</Show>
		// 		<Show when={shouldShowReports()}>
		// 			<ReportTable reports={reports()}></ReportTable>
		// 		</Show>
		// 	</div>
		// </div>
    )
}

interface GroupTableProps {
	groups: ReportGroup[]
}

const GroupTable = (props: GroupTableProps) => {
	const reportBrowser = useReportBrowser()!

	return (
		<div class="report-list-grid-container">
			<table>
				<thead>
					<tr>
						<th>Preview</th>
						<th>Group Name</th>
					</tr>
				</thead>
				<tbody>
					<For each={props.groups}>{(group) => (
						<tr onClick={() => reportBrowser.setSelectedGroup(group)} style="cursor: pointer">
							<td>
								<img class="report-browser-list-img" src={group.groupImage}></img>
							</td>
							<td>
								{group.description}
							</td>
						</tr>
					)}</For>
				</tbody>
			</table>
		</div>
	)
}

interface ReportTableProps {
	reports: ReportInfoCard[]
}

const ReportTable = (props: ReportTableProps) => {
	const reportBrowser = useReportBrowser()!
	
	return (
		<div class="report-list-grid-container">
			<table>
				<thead>
					<tr>
						<th>Preview</th>
						<th>Number</th>
						<th>Name</th>
						<th>Actions</th>
					</tr>
				</thead>
				<tbody>
					<For each={props.reports}>{(report) => (
						<tr>
							<td>
								<img class="report-browser-list-img" src={report.reportPreviewImage}></img>
							</td>
							<td>
								{report.number}
							</td>
							<td>
								{report.name}
							</td>
							<td>
								<div style="display: flex; gap: 8px;">
									<STButton type="primary" onClick={() => reportBrowser.launchReportInterface(report)}>Execute</STButton>
									<Show when={reportBrowser.state.isEditing}>
										<ReportEditMenu report={report}></ReportEditMenu>
									</Show>
								</div>
							</td>
						</tr>
					)}</For>

				</tbody>
			</table>
		</div>
	)
}